import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🙂", key: "small" },
  { emoji: "😕", key: "annoying" },
  { emoji: "😬", key: "expensive" },
  { emoji: "😣", key: "veryExpensive" },
]

export default function HomeMistakeCostPage() {
  return (
    <RadioCardListPage translationKey="homeMistakeCost" options={OPTIONS} />
  )
}
